export default __webpack_public_path__ + "static/media/crown.8619864b.svg";